export { TeamDetailScreen } from './TeamDetailScreen';
